import {useSnackbar} from 'notistack'
import {useMutation} from '@tanstack/react-query'
import {Button, Logo} from '@components/lib'
import {useTranslation} from 'react-i18next'
import {StringParam, useQueryParam, withDefault} from 'use-query-params'

import routes from 'routes'
import {useApi} from 'hooks'
import {TokenInfo} from 'constData'
import unsubscribeImg from 'images/common/unsubscribe.svg'

import {
  UnsubscribeBtns,
  UnsubscribeBtnWrapper,
  UnsubscribeContainer,
  UnsubscribeImg,
  UnsubscribeLogoLink,
  UnsubscribeSubTitle,
  UnsubscribeTitle,
} from './Unsubscribe.styles'

const Unsubscribe = () => {
  const api = useApi()
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar()
  const [token] = useQueryParam('token', withDefault(StringParam, null))

  const {
    mutate: unsubscribe,
    data,
    isLoading,
  } = useMutation(() => api.unsubscribeWithToken({token}), {
    onSuccess: ({success}) =>
      success &&
      enqueueSnackbar(t('profile.mailSubscription.nonAuthSuccessMessage'), {variant: 'success'}),
  })

  return (
    <UnsubscribeContainer>
      <UnsubscribeLogoLink to={routes.home.path}>
        <Logo />
      </UnsubscribeLogoLink>
      <UnsubscribeImg src={unsubscribeImg} alt='' />
      <UnsubscribeTitle>
        {!data?.success
          ? t('profile.mailSubscription.nonAuthTitle')
          : t('profile.mailSubscription.nonAuthSuccessTitle')}
      </UnsubscribeTitle>
      <UnsubscribeSubTitle>
        {!data?.success
          ? t('profile.mailSubscription.nonAuthDescription', {
              emailSupport: TokenInfo.MBASE.emailSupport,
            })
          : t('profile.mailSubscription.nonAuthSuccessDescription')}
      </UnsubscribeSubTitle>
      <UnsubscribeBtns>
        <UnsubscribeBtnWrapper>
          {!data?.success ? (
            <Button onClick={unsubscribe} isLoading={isLoading} size='sm' minWidth='140px'>
              {t('profile.mailSubscription.unsubscribeButton')}
            </Button>
          ) : (
            <Button to={routes.home.path} size='sm' minWidth='140px'>
              {t('profile.mailSubscription.homeButton')}
            </Button>
          )}
        </UnsubscribeBtnWrapper>
        {!data?.success && (
          <UnsubscribeBtnWrapper>
            <Button size='sm' minWidth='140px' nature='reject' to={routes.home.path}>
              {t('profile.mailSubscription.cancel')}
            </Button>
          </UnsubscribeBtnWrapper>
        )}
      </UnsubscribeBtns>
    </UnsubscribeContainer>
  )
}

export default Unsubscribe
